"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var event_1 = tslib_1.__importDefault(require("../utils/event"));
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var BasePlugin = /** @class */ (function (_super) {
    tslib_1.__extends(BasePlugin, _super);
    function BasePlugin(queue, config) {
        var _this = _super.call(this) || this;
        _this._editableOption = [];
        _this.queue = queue;
        _this.config = config;
        _this.globalConfig = _this.queue.config;
        return _this;
    }
    BasePlugin.prototype.setConfig = function (config) {
        var oldConfig = util_1.deepCopy(this.config);
        var changed = false;
        for (var _i = 0, _a = Object.keys(config); _i < _a.length; _i++) {
            var key = _a[_i];
            var value = config[key];
            if (this._editableOption.indexOf(key) > -1) {
                this.config[key] = value;
                if (oldConfig[key] !== value) {
                    changed = true;
                }
            }
        }
        if (changed) {
            this.emit('configChange', this.config, oldConfig);
        }
    };
    BasePlugin.prototype.addData = function (data) {
        if (this.isSampleHit() && this.handleBeforeSend(data)) {
            if (!util_1.isArray(data)) {
                if (data.tags) {
                    data.tags.sample_rate = this.getSample() / 100;
                }
                else {
                    data.tags = { sample_rate: this.getSample() / 100 };
                }
            }
            this.queue.add(data);
        }
    };
    BasePlugin.prototype.handleBeforeSend = function (data) {
        try {
            var hook = this.config.beforeSend;
            if (hook instanceof Function) {
                return Boolean(hook(util_1.deepCopy(data)));
            }
        }
        catch (error) {
            logger_1.default.log('beforeSend 处理异常', error);
        }
        return true;
    };
    /**
     * 根据指标配置的采样率判断该次上报是否命中采样
     * @returns {boolean} 是否命中采样
     */
    BasePlugin.prototype.isSampleHit = function () {
        return Math.random() * 100 <= this.getSample();
    };
    BasePlugin.prototype.getSample = function () {
        if (this.globalConfig.dev) {
            return 100;
        }
        return this.config.sampleRate;
    };
    BasePlugin.prototype.pluginDisabled = function () {
        return this.config.disable;
    };
    return BasePlugin;
}(event_1.default));
exports.default = BasePlugin;
//# sourceMappingURL=basePlugin.js.map